import { APPLICATION_DISPLAY_NAME } from '../../../config/config';

const resource = {
  localeId: 'dev',
  extendsLocale: undefined,
  resources: {
    // See: https://momentjs.com/docs/#/customization/calendar/
    'date-cal-last-day': `'Yesterday at' p`,
    'date-cal-same-day': `'Today at' p`,
    'date-cal-next-day': `'Tomorrow at' p`,
    'date-cal-last-week': `'Last' EEEE 'at' p`,
    'date-cal-next-week': `EEEE 'at' p`,
    'date-cal-same-else': `do MMM yyyy`,

    // e.g. "Updated Yesterday at 1pm" or "Updated Today at 1:30pm"
    'date-updated': 'Updated',
    ok: 'Ok',
    delete: 'Delete',

    // errors
    'error-load-templates-failed': 'Sorry, there was a problem loading templates',

    // actions
    'action-deletescribe-success-callout-title-text': 'Project deleted:',

    // authentication
    'authentication-applicationlogo-alt': `${APPLICATION_DISPLAY_NAME} logo`,
    'authentication-emailentryform-email-label': 'Email',
    'authentication-emailentryform-continue-button-text': 'Continue',
    'authentication-emailentryform-email-required-error': 'Looks like you forgot something!',
    'authentication-loginview-processingindicator-loggingin': 'Logging you in...',
    'authentication-loginview-login-error': 'There was a problem logging you in. Please try again.',
    'authentication-login-title': 'Log in to your account',
    'authentication-login-error-500':
      'Sorry, there’s a problem at our end and we can’t log you in at the moment. Please try again soon.',
    'authentication-login-error-400':
      'Your email address or password is incorrect. Please check your details and try again.',
    'authentication-login-warning-reduced-functionality': `Oh snap! – ${APPLICATION_DISPLAY_NAME} isn’t compatible with devices that are smaller than a tablet (screens less than 768px wide). But don’t worry! You can still enjoy ${APPLICATION_DISPLAY_NAME} to the full on all other devices.`,
    'authentication-signup-warning-reduced-functionality': `Oh snap! – ${APPLICATION_DISPLAY_NAME} isn’t compatible with devices that are smaller than a tablet (screens less than 768px wide). But don’t worry! You can still enjoy ${APPLICATION_DISPLAY_NAME} to the full on all other devices. Feel free to continue creating an account and you’ll be scribing in no time.`,
    'authentication-reset-password-title': 'Reset password',
    'authentication-passwordentryform-password-label': 'Password',
    'authentication-passwordentryform-password-required-error': 'Looks like you forgot something!',
    'authentication-signupform-title': 'Create your Sparkol account',
    'authentication-signupform-creating-account': 'Creating account...',
    'authentication-signupform-email-label': 'Email',
    'authentication-signupform-password-label': 'Choose a password',
    'authentication-signupform-password-secondary-label':
      'Must contain at least 8 characters including one uppercase letter, one lowercase letter, and a number.',
    'authentication-signupform-createaccount-button-text': 'Create account',
    'authentication-signupform-password-required-error': 'Please enter a valid password',
    'authentication-signupform-email-required-error': 'Please enter a valid email address',
    'authentication-signupform-first-name': 'First name',
    'authentication-signupform-firstname-required-error': 'Please enter a valid first name (Minimum 2 chars)',
    'authentication-signupform-last-name': 'Last name',
    'authentication-signupform-lastname-required-error': 'Please enter a valid last name (Minimum 2 chars)',
    'authentication-signupform-terms-1': "By continuing, you agree to Sparkol's ",
    'authentication-signupform-terms-2': 'terms and conditions',
    'authentication-signupform-terms-3': ' and our ',
    'authentication-signupform-email-exists-error': 'This email has been taken',
    'authentication-signupform-invalid-password-error':
      'Looks like your password doesn’t meet our policy. Please try again.',
    'authentication-signupform-general-error': 'Sorry something has happened, please try again.',
    'authentication-signupform-privacy-statement': ' privacy statement.',
    'authentication-signupform-marketing-label': 'Yes, please email me tips, tricks & gifts',
    'authentication-signupform-verification-error': 'Sorry, we can’t verify your details. Please try again',
    'authentication-signupform-code-mismatch-exception':
      'The verification code you entered is not correct, please check your email and try again',
    'authentication-pricing-link': 'Pricing',
    'authentication-templatelibrary-link': 'Template Library',
    'authentication-faqs-link': 'FAQs',
    'authentication-blog-link': 'Blog',
    'authentication-sparkol-link': 'Sparkol',
    'authentication-login-link': 'Log In',
    'authentication-signup-link': 'Sign Up',
    'authentication-contactus-link': 'Contact Us',
    'authentication-header-menu-label': 'Menu',
    'authentication-header-menu-close-label': 'Close',
    'authentication-footer-column1-header': `About ${APPLICATION_DISPLAY_NAME}`,
    'authentication-footer-column2-header': 'The app',
    'authentication-footer-column3-header': 'Subscribe to our newsletter',
    'authentication-footer-newsletter-copy':
      'Be the first to hear about special offers, new templates, and exclusive freebies!',
    'authentication-footer-copyright': '© 2021 Sparkol Ltd',

    // home
    'mobile-limitation-info':
      'Functionality is limited on small screens. Please use this on a larger screen for the full experience.',

    'home-delete-title': 'Delete Project?',
    'home-deletescribemodal-confirm-details-text': 'You are about to permanently delete the project',
    'home-deletescribemodal-warning-text': 'You will not be able to undo this action.',
    'home-deletescribemodal-delete-button-text': 'Ok, delete the project',
    'home-leftview-authenticate-with-contentful': 'Authenticate with Contentful',
    'home-previewtemplate-intro': 'Template preview',
    'home-previewtemplate-back': 'Back to templates',
    'home-previewtemplate-open': 'Use template',
    'home-previewtemplate-upgrade-to-edit': 'Upgrade to use template',
    'home-newscribemodal-intro': "Let's get started!",
    'home-newscribemodal-placeholder': 'Project name',
    'home-newscribemodal-title-required-error': 'Please give your project a name',
    'home-rightview-sortby-updateddate-option-text': 'Sort by recently used',
    'home-rightview-sortby-alphaascending-option-text': 'Sort A-Z',
    'home-rightview-sortby-alphadescending-option-text': 'Sort Z-A',
    'home-rightview-my-projects-button-text': 'My projects',
    'home-rightview-templates-button-text': 'Templates',
    'home-create-new-scribe': 'Create new project',

    'form-userpersona-title': 'Help us improve your experience!',
    'form-userpersona-dismiss': 'Close',
    'form-userpersona-previous': 'Previous step',
    'form-userpersona-next': 'Next step',
    'form-userpersona-done': 'Confirm',
    'form-userpersona-step1-question': 'Please select which of the below best describes you',
    'form-userpersona-step2-question': `What will you be using ${APPLICATION_DISPLAY_NAME} for?`,
    'form-userpersona-step2-tick-all': '(Tick all that apply)',

    // editor
    'editor-more': 'Show More Actions',
    'editor-newimageitem-title-text': 'Add image',
    'add-shape-circle': 'Circle/Ellipse',
    'add-shape-square': 'Square/Rectangle',
    'editor-add-image': 'Image',
    'editor-add-text': 'Text',
    'editor-add-shape': 'Shape',

    'editor-text-max-char-message': 'Maximum 90 characters per text element',
    'editor-text-max-char-description':
      'This is so your text can be nicely drawn out. Add a new text element if you need more text.',
    'editor-download-title-text': 'Download your project',
    'download-button': 'Start download',
    'editor-download-intro': 'Choose an export format',
    'download-button-disabled': 'Upgrade to download your project',
    'download-gif-description': 'Please note that GIFs are limited to the first 15 seconds of your project',
    'download-mp4-description': 'Long videos with full colors & audio. Higher file size',
    'download-close-confirm': 'Download progress will be lost, are you sure you want to cancel?',
    'download-finish-confirm': 'Congratulations! Your masterpiece has downloaded.',
    'download-limit-reached': 'You have reached your FREE download limit',
    'download-limit-remaining': 'You have 1 FREE download available on your account',
    'download-limit-remaining-plural': 'You have {{number}} FREE downloads available on your account',
    'download-success-upgrade': `Remove the watermark from your downloads by becoming a ${APPLICATION_DISPLAY_NAME} Creator`,

    'editor-tooltip-back-text': 'Save and back to Projects list',
    'editor-tooltip-cut-text': 'Cut',
    'editor-tooltip-copy-text': 'Copy',
    'editor-tooltip-paste-text': 'Paste',
    'editor-tooltip-record': 'Project audio',
    'editor-tooltip-playback-text': 'Playback from current element',
    'editor-tooltip-playback-full-text': 'Playback from start',
    'editor-tooltip-preview': 'Preview your project',
    'editor-tooltip-download': 'Download as video or GIF',
    'editor-tooltip-hands-text': 'Drawing hand',
    'editor-tooltip-undo': 'Undo',
    'editor-tooltip-redo': 'Redo',
    'editor-tooltip-text-align-left': 'Align left',
    'editor-tooltip-text-align-center': 'Align centre',
    'editor-tooltip-text-align-right': 'Align right',
    'editor-tooltip-text-align-bold': 'Bold',
    'editor-tooltip-text-align-italic': 'Italic',
    'editor-tooltip-text-turn-grid-on': 'Grid on',
    'editor-tooltip-text-turn-grid-off': 'Grid off',
    'editor-tooltip-preview-disabled': 'Add elements with animation time to preview your project',
    'editor-tooltip-download-disabled-no-timings': 'Add elements with animation time to download your project',
    'editor-tooltip-download-disabled-images-uploading': 'Download available once images finish uploading',
    'editor-tooltip-download-disabled-images-broken':
      'Replace the broken images on the canvas to download your project.',
    'editor-tooltip-play-disabled': 'Add elements with animation time to play your project',

    'editor-tooltip-preview-broken-image-disabled':
      'Replace/remove the broken images on the canvas to preview your project.',

    'editor-menu-upgrade': 'Upgrade',
    'editor-menu-download': 'Download',
    'editor-menu-preview': 'Preview',
    'editor-menu-save-as-template': 'Save as template',
    'editor-play-buttons-element': 'Play from element',
    'editor-play-buttons-scene': 'Play from scene',

    'record-start-error-title': 'Cannot start recording',
    'record-start-error-message': 'To start recording, allow this site access to your microphone',

    //shared components
    'shared-offlinewarning-title': 'You are currently working in offline mode.',
    'shared-offlinewarning-secondary': 'Please restore connection',
    'share-offlinewarning-close-tab-message':
      'You are currently offline. If you close this tab you might lose unsaved changes. Are you sure you want to close?',

    'ap-heading': 'Appearance',

    'cp-color-color': 'Color',
    'cp-color-default': 'Default',
    'cp-color-custom': 'Custom',
    'cp-color-solid': 'Single color',
    'cp-color-gradient': 'Gradient',
    'cp-color-vertical': 'Vertical',
    'cp-color-horizontal': 'Horizontal',
    'cp-right-color-label': 'Right color',
    'cp-left-color-label': 'Left color',
    'cp-start-color-label': 'Start color',
    'cp-top-color-label': 'Top color',
    'cp-bottom-color-label': 'Bottom color',
    'cp-end-color-label': 'End color',
    'cp-opacity': 'Opacity',
    'cp-preview': 'Preview',
    'cp-hex-code': 'Hex code',
    'cp-red-single-char': 'R',
    'cp-green-single-char': 'G',
    'cp-blue-single-char': 'B',
    'cp-color-skin': 'Skin tones',
    'cp-color-hair': 'Hair color',

    saving: 'Saving...',

    'authentication-form-note-intro-text': 'Please note:',
    'authentication-login-link-text': `log straight into ${APPLICATION_DISPLAY_NAME}`,
    'authentication-login-info-text': 'Already have a Sparkol account? Skip this step and  ',
    'authentication-login-info-text-2': ' to start animating.',
    'authentication-createaccount-link-text': 'Create an account',
    'authentication-createaccount-info-text': `New to ${APPLICATION_DISPLAY_NAME}? `,
    'authentication-createaccount-login': 'Log in',
    'authentication-forgetpassword-link-text': 'Forgot your password?',
    'authentication-forgetpassword-title': 'Reset your password',
    'authentication-forgetpassword-info':
      "Forgot your password? Don't worry! We'll send you an email to help you reset it.",
    'authentication-forgetpassword-confirm-info':
      "Check your inbox. We've just sent you an email to help you reset your password.",
    'authentication-resetpassword-confirmation': 'Password reset successfully',
    'authentication-resetpassword-open-app': "Let's go!",
    'authentication-forgetpassword-button-text': 'Submit',
    'authentication-resetpassword-password': 'New password',
    'authentication-resetpassword-confirm-password': 'Confirm new password',
    'authentication-resetpassword-button-text': 'Set password',
    'authentication-resetpassword-password-confirmation-error': 'Looks like passwords are not correct',
    'authentication-resetpassword-auth-code-label': 'Verification code',
    'authentication-resetpassword-password-policy':
      'Your new password must contain at least 8 characters including one uppercase letter, one lowercase letter, and a number.',
    'authentication-resetpassword-verification-code-error': 'Please enter your verification code',

    // upgrade modal
    'checkout-summary-title': 'Upgrade me to Creator',
    'checkout-summary-bill-info': 'each month',
    'checkout-summary-bill-tax-calc': 'Tax confirmed once ZIP/Postal code entered',
    'checkout-summary-package-info-1': 'No watermarks on downloads',
    'checkout-summary-package-info-2': 'Unlimited downloads per month',
    'checkout-summary-package-info-3': 'Unlimited projects',
    'checkout-summary-tax': 'Tax ',
    'checkout-summary-total-to-pay': 'Total to pay today :',
    'checkout-payment-cards-copy': 'Secure card payment',
    'checkout-terms-and-conditions-copy-1': 'By placing my order for my recurring subscription I am accepting the',
    'checkout-terms-and-conditions-copy-2': 'Terms and Conditions',
    'checkout-cta-button': 'Purchase now',
    'payment-confirm-processing': 'Processing payment...',
    'payment-confirm-title': "Wooot! You're upgraded",
    'payment-confirm-copy-1': "Thank you for your purchase. A confirmation email is on it's way to ",
    'payment-confirm-copy-2': 'You can find info on your subscription in your ',
    'payment-confirm-account': 'account ',
    'payment-confirm-anytime': 'anytime.',
    'payment-confirm-get-back': 'Get back to scribing like a megastar',
    'payment-failed-title': 'The payment has failed',
    'payment-failed-copy': 'Try again or contact us.',
    'payment-failed-purchase-now': 'Purchase now',

    'existing-vsd-user': "As you already have a Sparkol account, we'll use the payment method attached to it:",
    'existing-vsd-user-card': 'Credit card ending in ',
    'existing-vsd-user-paypal': 'Payment via ',
    'existing-vsd-user-expiry': 'Expires: ',
    'existing-vsd-user-expired': 'Expired: ',
    'existing-vsd-user-purchase-now': 'Purchase now',
    'update-payment-details-1': 'You can change your payment details ',
    'update-payment-details-2': 'here.',
    'existing-vsd-user-card-expired-copy-1':
      'You already have a Sparkol account, but your payment method has expired. Please',
    'existing-vsd-user-card-expired-copy-2': 'click here',
    'existing-vsd-user-card-expired-copy-3': 'to update it.',

    // Image browse panel
    'image-browse-my-images': 'Your images',
    'image-browse-upload-max-exceeded': 'You have exceeded the maximum number of simultaneous uploads',
    'image-browse-upload-more-than-5-images': 'Maximum 5 images at a time',
    'image-browse-no-images-message': 'You have no images imported. Use the import image button to upload your own.',
    'image-browser-confirm-message': 'Are you sure you want to delete this image from your library?',

    loading: 'Loading ...',
    'image-libraries': 'Image libraries',
    'image-libraries-select': 'Browse libraries',
    'search-keywords': 'Search keywords',
    'search-placeholder': 'e.g. buildings, technology, vehicles',
    'clear-search': 'Clear search',
    'no-results': 'No Results for Search Query',
    'create-scribe': 'Create project',
    'new-text-element-default-text': 'Enter text here ...',
    'canvas-size-landscape': 'Size 16:9',
    'canvas-size-landscape-info': 'Great for YouTube or website content',
    'canvas-size-portrait': 'Size 9:16',
    'canvas-size-portrait-info': 'Ideal for Instagram or Facebook stories',
    'canvas-size-square': 'Size 1:1',
    'canvas-size-square-info': 'Perfect for Instagram or Facebook',
    'address-lookup-label': 'Please enter a valid',
    'billing-location-label': 'You are buying from',
    'billing-location-select-button-label': "If this isn't right, ",
    'billing-location-select-button-text': 'change your location',
    'billing-location-select-label': 'Please select your country...',
    'billing-location-select-default-text': 'Select...',

    // Loading spinner
    'spinner-logging-in': 'Logging in...',
    'spinner-creating-new-scribe': 'Creating project...',
    'spinner-authenticating': 'Authenticating...',

    // View only
    'view-only': 'View only',
    'view-only-blurb':
      'Free plan users can edit their 3 most recent projects. All other projects are view-and-playback only.',

    'delete-element-button-text': 'Delete',

    // Edit Panels
    'transform-edit-panel-title': 'Transform',
    'transform-edit-panel-transform-controls': 'Transform controls',
    'transform-edit-panel-lock-position': 'Lock element position',
    'transform-edit-panel-lock-positions': 'Lock element positions',
    'transform-edit-panel-free-transform-allow-distortion': 'Free transform (allow distortion)',
    'transform-edit-panel-flip-object': 'Flip object',
    'transform-edit-panel-flip-vertically': 'Flip vertically',
    'transform-edit-panel-flip-horizontally': 'Flip horizontally',

    'timing-edit-panel-timing': 'Timing',
    'timing-edit-panel-animation': 'Animation',
    'timing-edit-panel-pause': 'Pause',

    'text-edit-panel-text': 'Text',
    'text-edit-panel-font': 'Font',

    'background-settings-panel-title': 'Background settings',

    'image-color-panel-reset': 'Reset',
    'image-color-panel-fill1': 'Fill 1',
    'image-color-panel-fill2': 'Fill 2',
    'image-color-panel-skin': 'Skin',
    'image-color-panel-hair': 'Hair',
    'image-color-panel-stroke': 'Stroke',
    'image-color-panel-highlight': 'Highlight',

    'cursor-pens-tab': 'Pens',
    'cursor-hands-tab': 'Hands',

    // Modal defaults
    'modal-default-confirm-label': 'Confirm',
    'modal-default-cancel-label': 'Cancel',

    // Cursor Options Modal
    'cursor-options-modal-title': 'Default drawing hand options',
    'cursor-options-modal-confirm-label': 'Confirm default hand',
    'cursor-options-modal-intro':
      'Choose your default animation drawing hand - a hand, pen, or nothing at all - for each new element you add to your canvas. Want to have a variety? You can override the default drawing hand by selecting your element, and heading to the "Animation" tab to pick a different drawing hand.',

    // Template Tile
    'template-tile-open': 'Use',
    'template-tile-preview': 'Preview',
    'template-tile-upgrade-to-edit': 'Upgrade to use',

    // Download progress modal
    'download-progress-modal-title': 'Downloading project',
    'download-progress-modal-intro-message': 'Hang tight, this may take a few minutes.',
    'download-progress-modal-status-label': 'Status',
    'download-progress-modal-error-detected':
      "Uh-oh! We've hit a roadblock. Click 'Retry' to download your project again",
    'download-progress-modal-retry-label': 'Retry',
    'download-progress-bar-complete': 'complete',

    // Playback Error Boundary
    'playback-error-boundary-title': 'Oops! There was an issue during playback of your project.',
    'playback-error-boundary-desc':
      'This may be due to incompatibilities with your web browser. Video downloads of your project should be unaffected - so give it a try.',
    'playback-error-boundary-cta': 'Try download',

    // Upgrade Banner
    'upgrade-banner-copy': `[Current subscription: ${APPLICATION_DISPLAY_NAME} Free] Upgrade to Creator to remove watermarks`,

    'broken-image-tooltip': 'Broken image (failed to load)'
  }
};

export default resource;
